import { sumBy } from 'lodash';
import type { RoomTypeInternalValue } from '~/components/BookingFlow/Overview/RoomTypes';

const emptyRow: RoomTypeInternalValue = {
  order_session_room_type_id: null,
  service_code: null,
  pax: 0,
};

export default function roomTypeResolver(
  rows: RoomTypeInternalValue[],
  pax: number,
) {
  const selectedPaxCount = sumBy(rows, 'pax');
  const paxLeft = pax - selectedPaxCount;

  // If there're no rows, add an initial empty row.
  if (!rows.length) {
    return [{ ...emptyRow }];
  }

  const emptyRows = rows.filter((row) => row.service_code === null);

  // If there're more than one empty row, remove the duplicate empty rows.
  if (emptyRows.length > 1) {
    // Remove all empty rows
    const newRows = rows.filter((row) => row.service_code !== null);

    // Add a new empty row
    newRows.push({ ...emptyRow });

    return newRows;
  }

  // If there're empty rows, do nothing, the user can select a rows.
  if (emptyRows.length > 0) {
    // If the number of selected pax already exceeds the required pax,
    // remove the empty rows.
    if (selectedPaxCount >= pax) {
      return rows.filter((row) => row.service_code !== null);
    }

    return rows;
  }

  // If there're still pax left to assign to rooms, add a new empty row.
  if (paxLeft > 0) {
    return [
      ...rows,
      {
        order_session_room_type_id: null,
        service_code: null,
        pax: 0,
      },
    ];
  }

  // If the number of selected pax exceeds the required pax, remove the empty rows.
  if (paxLeft < 0) {
    let paxCount = 0;

    return rows
      // Remove empty rows
      .filter((row) => row.service_code !== null)
      // Remove rows that exceed the required pax
      .filter((row) => {
        paxCount += row.pax;
        return paxCount <= pax;
      });
  }

  return rows;
}
